import React, { Dispatch, useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Card,
  InputGroup,
  Form,
  Pagination,
  Button,
} from "react-bootstrap";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { VscExport } from "react-icons/vsc";
import { IoSearchOutline } from "react-icons/io5";
import Grid, {
  GridColumn,
  GridHeader,
  GridRow,
} from "../../../components/Grid/Grid";
import { useDispatch } from "react-redux";
import { BsEye } from "react-icons/bs";
import HelperService from "../../../utility/HelperService";
import { connect, useSelector } from "react-redux";
import {
  projectUnitEditPageRequest,
  projectUnitsRequest,
  projectUnitDeleteConfirm,
  projectUnitDeleteDecline,
  projectUnitDeleteRequest,
} from "../../ProjectsUnit/ProjectUnitAction";
import {
  ProjectUnitInterface,
  ProjectUnitState,
  projectUnitStatus,
} from "../../ProjectsUnit/ProjectUnitTypes";
import { permissionsInterface, reduxInitialState } from "../../onBoarding/onBoardingTypes";
import { navigationRequest } from "../../../Navigation/NavigationRedux/NavigationRedux";
import PageTitle from "../../../components/PageTitle/PageTitle";
import { Pencil, Plus, Trash } from "react-bootstrap-icons";
import routePaths from "../../../Navigation/routePaths";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import WebService from "../../../utility/WebService";
import { toast } from "react-toastify";
import { decrypt } from "../../../utility/cryptoUtils";

const headers: GridHeader[] = [
  {
    title: "Date",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "created_at",
  },
  {
    title: "Receipt ID",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "receipt_id",
  },
  {
    title: "Customer Name",
    class: "text-left"
  },
  {
    title: "Project name",
    class: "text-left",
    isSorting: false,
    // isAsc: true,
    // sortingKey: "project.project_name",
  },
  {
    title: "Total Cost",
    class: "text-left",
    isSorting: false,
    // isAsc: true,
    // sortingKey: "booking.total_cost",
  },
  {
    title: "Paying Amount",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "paying_amount",
  },
  {
    title: "Payment mode",
    class: "text-left",
    isSorting: true,
    isAsc: true,
    sortingKey: "payment_mode",
  },
  {
    title: "Comment",
    class: "text-left",
  },
  {
    title: "Action",
    class: "text-center freeze-column",
    headerClass: "text-center",
    isFilter: false,
    isFreeze: true,
  },
];

const ReceiptPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id }: any = useParams();
  const nextOffset = useRef<number>(0);
  const keyword = useRef<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [receiptList, setReceiptList] = useState<any[]>([]);
  const [receiptId, setReceiptId] = useState<string>("");
  const [showDeleteModal, setDeleteModal] = useState<boolean>(false);
  const [rows, setRows] = useState<GridRow[]>([]);
  const rowCompute = useRef<GridRow[]>([]);
  const [showHiddenFields, setShowHiddenFields] = useState<boolean>(false);
  const [pressedKeys, setPressedKeys] = useState(new Set());
  const [totalCount, setTotalCount] = useState<number>(0);
  const token = useSelector((state: any) => state.OnBoardingReducer);
  const [permissions, setPermissions] = useState<permissionsInterface | null>(null);

  useEffect(() => {
    if (token && token.token && token.permissions && !!token.permissions.length) {
      setPermissions(token.permissions.find((item: any) => item.name === "RECEIPTS"));
    }
  }, [token])

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
    };
  }, [pressedKeys]);

  useEffect(() => {
    showHiddenFields && getReceiptList(1);
  }, [showHiddenFields]);

  const actionList = (data: any) => {
    return (
      <div className="action-btns">
        {permissions && permissions.can_update && <button
          className="cursor-pointer  btn-edit btn"
          onClick={() => onEdit(data)}
        >
          {" "}
          <Pencil />{" "}
        </button>}
        {permissions && permissions.can_delete && <button
          onClick={() => onConfirmDelete(data)}
          className="cursor-pointer btn btn-delete"
        >
          {" "}
          <Trash />{" "}
        </button>}
      </div>
    );
  };

  const onEdit = (val: any) => {
    setReceiptId(val);
    // setTimeout(() => {
    navigate("/update-receipt/" + val, { state: { type: showHiddenFields ? "REAL" : "FAKE" } });
    // }, 100);
  };

  const onConfirmDelete = (val: any) => {
    setReceiptId(val);
    setDeleteModal(true);
  };

  const getReceiptList = (
    offset: number,
    keyword?: string,
    startDate?: Date,
    endDate?: Date,
    order_by?: string,
    sort_by?: string
  ) => {
    const params: any = new URLSearchParams(window.location.search);
    const booking_id = params.get("booking");
    if (booking_id) {
      params.delete("booking");
      // const newQueryParameters: URLSearchParams = new URLSearchParams();
      // newQueryParameters.delete("booking");
      // setSearchParams(newQueryParameters);
      // navigate(routePaths.RECEIPT.path, { replace: true });
    }

    nextOffset.current = offset;
    if (nextOffset.current < 0 || isLoading) {
      return;
    }
    nextOffset.current == 0 && setIsLoading(true);
    WebService.getAPI({
      action: `receipt/pagination/list?limit=10&offset=${offset}&keyword=${keyword ? keyword : ""
        }&sort_by=${order_by ?? "asc"}&order_by=${sort_by ?? "created_at"}&from_date=${startDate ? startDate : ""}&to_date=${endDate ? endDate : ""
        }&booking_id=${booking_id ? booking_id : ""}`,
      body: null,
      is_session: showHiddenFields
    })
      .then((res: any) => {
        setIsLoading(false);
        setTotalCount(res.count);
        setReceiptList(res.list);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const onSortList = (offset: number, isAscending?: boolean, key?: string) => {
    getReceiptList(
      offset,
      null as any,
      null as any,
      null as any,
      isAscending ? "asc" : "desc",
      key
    );
  };

  const onDelete = () => {
    setDeleteModal(false);
    setIsLoading(true);
    WebService.deleteAPI({
      action: `receipt/delete/${receiptId}`,
      body: null,
      is_session: showHiddenFields
    })
      .then((res: any) => {
        setIsLoading(false);
        toast.success(res.message);
        setReceiptId("");
        getReceiptList(1);
      })
      .catch((e) => {
        setIsLoading(false);
        setReceiptId("");
      });
  };

  const handleKeyDown = (e: any) => {
    const key = e.key.toLowerCase();
    setPressedKeys((prev: any) => new Set([...prev, key]));
  };

  const handleKeyUp = (e: any) => {
    const key = e.key.toLowerCase();
    // Check for ctrl+p+t
    if (pressedKeys.has('control') && pressedKeys.has('alt') && pressedKeys.has('o') && pressedKeys.has('p')) { setShowHiddenFields(true); }
    // Remove the key from the set
    setPressedKeys((prev: any) => { const updated = new Set(prev); updated.delete(key); return updated; });
  };

  const getFormatedProjectRow = (list: any[]) => {
    let rows: GridRow[] = [];
    for (var i in list) {
      let columns: GridColumn[] = [];
      columns.push({ value: list[i].created_at && HelperService.getFormatedDate(list[i].created_at) });
      columns.push({ value: list[i].receipt_id ? list[i].receipt_id : "N/A" });
      columns.push({ value: list[i].customer_name ? list[i].customer_name : "N/A" });
      columns.push({ value: list[i].project_name ? list[i].project_name : "N/A" });
      columns.push({ value: HelperService.getCurrencyFormatter(list[i].total_cost) });
      columns.push({ value: HelperService.getCurrencyFormatter(list[i].paying_amount) });
      columns.push({ value: list[i].payment_mode ? HelperService.capitalizeFirstLetter(list[i].payment_mode) : "N/A" });
      columns.push({ value: list[i].comment ? list[i].comment : "N/A", });
      columns.push({ value: actionList(list[i].uuid), type: "COMPONENT", });
      rowCompute.current.push({ data: columns });
      rows.push({ data: columns });
    }
    // rowCompute.current = rows;
    // setRows(rowCompute.current);
    return rows;
  };


  return (
    <>
      <DeleteModal isShow={showDeleteModal} close={() => { setDeleteModal(false); }} onDelete={() => { onDelete(); }} />
      {permissions && permissions.can_read && <div className="app-page page-dashboard">
        <div className="d-flex justify-content-between align-items-center ">
          <PageTitle title="Receipts" backArrow={false} active={showHiddenFields} />
          {/* {permissions && permissions.can_write && <Button className="btn btn-brand-1 mb-3" onClick={() => navigate(routePaths.RECEIPT_CREATE.path)}>
            {" "}<Plus size={20} className="ms-1" /> Add Receipt
          </Button>} */}
        </div>
        <div className="table-card">
          <Grid
            rows={getFormatedProjectRow(receiptList)}
            showSearch={true}
            headers={headers}
            showDateFilter={true}
            onPageChange={getReceiptList}
            errorMessage={"No Receipt Found"}
            ShowLoader={isLoading}
            onSort={onSortList}
            count={totalCount}
          />
        </div>
      </div>}
    </>
  );
};

export default ReceiptPage;
